import React from 'react'
import AdminSidebar from '../components/AdminSidebar'

const AdminTermsOfService: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-backgroundColorBg2">
      <AdminSidebar />
      <div className="flex-1 flex flex-col">
        <div className="bg-white border-b border-brandPrimary-10% p-24px">
          <h1 className="font-pretendard font-bold text-24px text-textColorText2">
            이용약관
          </h1>
        </div>
        <div className="flex-1 overflow-y-auto scrollbar-hide p-24px">
          <div className="max-w-4xl bg-white rounded-8px p-24px">
            <div className="flex flex-col gap-16px">
              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제1조 (목적)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed">
                  본 약관은 tastee 서비스(이하 "서비스")의 이용과 관련하여
                  회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로
                  합니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제2조 (정의)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed whitespace-pre-wrap">
                  1. "서비스"란 tastee가 제공하는 모든 서비스를 의미합니다. 2.
                  "이용자"란 서비스에 접속하여 본 약관에 따라 서비스를 이용하는
                  회원 및 비회원을 의미합니다. 3. "회원"이란 서비스에 개인정보를
                  제공하여 회원등록을 한 자로서, 서비스의 정보를 지속적으로
                  제공받으며 서비스를 계속적으로 이용할 수 있는 자를 의미합니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제3조 (약관의 효력 및 변경)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed whitespace-pre-wrap">
                  1. 본 약관은 서비스를 이용하고자 하는 모든 이용자에게 효력이
                  발생합니다. 2. 회사는 필요하다고 인정되는 경우 본 약관을
                  변경할 수 있으며, 변경된 약관은 서비스 내 공지사항을 통해
                  공지합니다. 3. 이용자가 변경된 약관에 동의하지 않는 경우,
                  서비스 이용을 중단할 수 있습니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제4조 (서비스의 제공)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed whitespace-pre-wrap">
                  1. 회사는 다음과 같은 서비스를 제공합니다: - 음식점 리뷰 및
                  평가 서비스 - 음식점 비교 및 추천 서비스 - 커뮤니티 서비스 -
                  기타 회사가 정하는 서비스 2. 서비스는 연중무휴, 1일 24시간
                  제공함을 원칙으로 합니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제5조 (이용자의 의무)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed whitespace-pre-wrap">
                  이용자는 다음 행위를 하여서는 안 됩니다: 1. 신청 또는 변경시
                  허위 내용의 등록 2. 타인의 정보 도용 3. 회사가 게시한 정보의
                  변경 4. 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의
                  송신 또는 게시 5. 회사 기타 제3자의 저작권 등 지적재산권에
                  대한 침해 6. 회사 기타 제3자의 명예를 손상시키거나 업무를
                  방해하는 행위
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제5조의2 (부적절한 콘텐츠 및 남용 행위에 대한 제로 톨러런스)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed whitespace-pre-wrap">
                  1. 회사는 부적절한 콘텐츠 및 남용 행위에 대하여 제로
                  톨러런스(Zero Tolerance) 정책을 적용합니다. 2. 부적절한
                  콘텐츠란 다음을 포함합니다: - 성적, 폭력적, 혐오적 내용 -
                  차별적이거나 괴롭힘을 조장하는 내용 - 불법적이거나 유해한 내용
                  - 타인의 권리를 침해하는 내용 - 허위 정보나 오해의 소지가 있는
                  내용 - 기타 공서양속에 반하는 내용 3. 남용 행위란 다음을
                  포함합니다: - 다른 이용자를 괴롭히거나 위협하는 행위 - 스팸,
                  도배, 반복적인 무의미한 메시지 전송 - 사기, 기만, 허위 정보
                  제공 - 서비스의 정상적인 운영을 방해하는 행위 - 기타 다른
                  이용자에게 불쾌감을 주거나 서비스 이용을 방해하는 행위 4.
                  이용자가 부적절한 콘텐츠를 게시하거나 남용 행위를 하는 경우,
                  회사는 사전 통보 없이 즉시 다음 조치를 취할 수 있습니다: -
                  해당 콘텐츠의 즉시 삭제 - 해당 이용자의 서비스 이용 제한 또는
                  계정 정지 - 관련 법령에 따른 법적 조치 5. 회사는 이용자 신고를
                  받은 경우, 24시간 이내에 신고 내용을 검토하고 필요한 조치를
                  취합니다. 6. 이용자는 부적절한 콘텐츠나 남용 행위를 발견한
                  경우, 서비스 내 신고 기능을 통해 신고할 수 있습니다. 7. 본
                  조항의 위반으로 인한 이용 제한 또는 계정 정지에 대하여 회사는
                  어떠한 책임도 지지 않으며, 이로 인한 손해에 대하여도 배상하지
                  않습니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제6조 (개인정보보호)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed">
                  회사는 관련법령이 정하는 바에 따라서 이용자 등록정보를 포함한
                  이용자의 개인정보를 보호하기 위해 노력합니다. 이용자의
                  개인정보보호에 관해서는 관련법령 및 회사가 정하는
                  개인정보처리방침에 정한 바에 의합니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제7조 (면책조항)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed whitespace-pre-wrap">
                  1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여
                  서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이
                  면제됩니다. 2. 회사는 이용자의 귀책사유로 인한 서비스 이용의
                  장애에 대하여는 책임을 지지 않습니다. 3. 회사는 이용자가
                  서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을
                  지지 않습니다.
                </p>
              </div>

              <div>
                <h2 className="font-pretendard font-bold text-18px text-textColorText2 mb-8px">
                  제8조 (준거법 및 관할법원)
                </h2>
                <p className="font-pretendard font-regular text-16px text-textColorText2 leading-relaxed">
                  본 약관은 대한민국 법률에 따라 규율되고 해석되며, 회사와
                  이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상의
                  관할법원에 제소합니다.
                </p>
              </div>

              <div className="mt-24px">
                <p className="font-pretendard font-regular text-14px text-textColorText3">
                  본 약관은 2026년 1월 1일부터 시행합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminTermsOfService
